module.exports = __webpack_public_path__ + "img/Skärgård-2.c8ec3e7d.jpg";